// src/utils/referrals.js

import { db } from "../firebase";
import { collection, query, where, getDocs } from "firebase/firestore";

// Get direct referrals by referral code
export const getDirectReferrals = async (referralCode) => {
    const q = query(
        collection(db, "referral_users"),
        where("referredBy", "==", referralCode)
    );
    const snapshot = await getDocs(q);
    return snapshot.docs.map(doc => doc.data());
};
